import { useUser } from "@clerk/clerk-react";
import { FormEvent, useState } from "react";
import { clerkMessage } from "../lib/clerkError";

export function AccountPassword() {
  const { user } = useUser();
  const hasPassword = user?.passwordEnabled ?? false;
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);

  async function save(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!user) return;
    if (newPassword.length < 15) {
      setError("密码至少 15 位。");
      setDone("");
      return;
    }
    setBusy(true);
    setError("");
    setDone("");
    try {
      await user.updatePassword({
        newPassword,
        currentPassword: hasPassword ? currentPassword : undefined,
        signOutOfOtherSessions: false,
      });
      setCurrentPassword("");
      setNewPassword("");
      setDone(hasPassword ? "密码已修改，当前登录还在。" : "密码已设置，当前登录还在。");
    } catch (cause) {
      setError(clerkMessage(cause, "密码没有改成。"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="stack" autoComplete="on" onSubmit={save}>
      <h2>{hasPassword ? "修改密码" : "设置密码"}</h2>
      <p className="muted">至少 15 位。已泄露的密码不能用。改完不会退出这次登录。</p>
      {hasPassword ? (
        <label>
          当前密码
          <input
            type="password"
            name="current-password"
            autoComplete="current-password"
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
            required
          />
        </label>
      ) : null}
      <label>
        新密码
        <input
          type="password"
          name="new-password"
          autoComplete="new-password"
          minLength={15}
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value)}
          required
        />
        <small>至少 15 位</small>
      </label>
      {error ? <p className="inline-error">{error}</p> : null}
      {done ? <p className="muted">{done}</p> : null}
      <button type="submit" className="button line" disabled={busy || !user}>
        {busy ? "请稍等" : hasPassword ? "修改密码" : "设置密码"}
      </button>
    </form>
  );
}
